import {
  CognitoUserPool,
  CognitoUser,
  AuthenticationDetails,
  CognitoRefreshToken,
  type CognitoUserSession,
} from 'amazon-cognito-identity-js';
import { COGNITO } from './config';

const userPool = new CognitoUserPool({
  UserPoolId: COGNITO.userPoolId,
  ClientId: COGNITO.clientId,
});

export interface SessionResult {
  idToken: string;
  accessToken: string;
  refreshToken: string;
  expiresAt: number;
}

function sessionToResult(session: CognitoUserSession): SessionResult {
  const idToken = session.getIdToken();
  return {
    idToken: idToken.getJwtToken(),
    accessToken: session.getAccessToken().getJwtToken(),
    refreshToken: session.getRefreshToken().getToken(),
    expiresAt: idToken.getExpiration() * 1000,
  };
}

export function srpLogin(email: string, password: string): Promise<SessionResult> {
  return new Promise((resolve, reject) => {
    const user = new CognitoUser({ Username: email.toLowerCase(), Pool: userPool });
    const details = new AuthenticationDetails({ Username: email.toLowerCase(), Password: password });
    user.authenticateUser(details, {
      onSuccess: (session) => resolve(sessionToResult(session)),
      onFailure: (err) => reject(err),
      newPasswordRequired: () => reject(new Error('new_password_required')),
      mfaRequired: () => reject(new Error('mfa_required')),
    });
  });
}

export function refreshSession(email: string, refreshToken: string): Promise<SessionResult> {
  return new Promise((resolve, reject) => {
    const user = new CognitoUser({ Username: email.toLowerCase(), Pool: userPool });
    user.refreshSession(new CognitoRefreshToken({ RefreshToken: refreshToken }), (err, session) => {
      if (err) return reject(err);
      resolve(sessionToResult(session));
    });
  });
}

export function signOutLocal(email: string): void {
  try { new CognitoUser({ Username: email.toLowerCase(), Pool: userPool }).signOut(); } catch { /* */ }
}
